import { render, staticRenderFns } from "./SpecialSixTitle.vue?vue&type=template&id=348f5684&scoped=true"
import script from "./SpecialSixTitle.vue?vue&type=script&lang=js"
export * from "./SpecialSixTitle.vue?vue&type=script&lang=js"
import style0 from "./SpecialSixTitle.vue?vue&type=style&index=0&id=348f5684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f5684",
  null
  
)

export default component.exports